import type { FaireProductEntity } from "../../entity_types/product";

export const ramen_11: FaireProductEntity = {
  token: "ramen-11",
  type: "product",
  name: "Hot Garlic Chili Crisp",
  brandName: "Mama Teav's",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4284b676e76aa12c9f11473e6c3c82e6be32522ff7cdbfbcefe59951d37c17bd.png",
  priceDollars: 10,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4284b676e76aa12c9f11473e6c3c82e6be32522ff7cdbfbcefe59951d37c17bd.png",
  weight: 0.3,
  dimensions: {
    width: 3,
    height: 5,
    depth: 3,
  },
  description: "Hot garlic chili crisp for ramen enhancement",
  categoryTokens: ["cat_food-snacks"],
  tags: [
    "ramen",
    "japanese-ramen",
    "chili-crisp",
    "garlic",
    "condiment",
    "premium",
  ],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
